import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    position: 'relative',
  },
  edit: {
    position: 'absolute',
    right: 12,
    bottom: 12,
    zIndex: '10',
    pointerEvents: 'all',
    [theme.breakpoints.down('md')]: {
      left: 12,
      maxWidth: 'calc(100% - 48px)',
      textAlign: 'left',
      top: 12,
    },
  },
  error: {
    position: 'absolute',
    zIndex: '4', // needs to be visible over the map and popover
    top: 54,
    left: 12,
    color: 'rgb(244, 67, 54)',
    [theme.breakpoints.down('md')]: {
      left: 12,
      maxWidth: 'calc(100% - 48px)',
      textAlign: 'left',
      top: 60,
    },
  },
  map: {
    [theme.breakpoints.down('md')]: {
      pointerEvents: 'none',
    },
    '& *': {
      [theme.breakpoints.down('md')]: {
        pointerEvents: 'none',
      },
    },
  },
}))
